import { useEffect, useState } from 'react'

import { useIsSimulation } from '@/hooks'

export function useFieldIsVisible(
  recurrenceSettingsValue: uui.domain.ui.forms.BulkRecurrenceSettings,
) {
  const [visible, setVisible] = useState(false)
  const isSimulation = useIsSimulation()

  useEffect(() => {
    const recurrenceEnabled =
      recurrenceSettingsValue.status === 'exact' &&
      recurrenceSettingsValue.value?.recurrencePeriod.recurrenceType === 'NO_REPEAT'

    setVisible(recurrenceEnabled || isSimulation)
  }, [isSimulation, recurrenceSettingsValue])

  return visible
}
